import "./credits.scss"
import { motion } from "framer-motion";
import { creditsFadeInUpVariants } from "../../utils/motionUtils";

const Credits = () => {
	return (
		<motion.footer
			variants={creditsFadeInUpVariants}
			initial='initial'
			animate='animate'
			exit='exit'
			className='Credits'
		>
			<span>Developed by</span>
			<motion.a whileTap={{scale: 0.9}} className='Credits__linkwrp' href={"https://omniaverse.io"} target='_blank' rel='noreferrer'>
				<span> OmniaVerse </span>
			</motion.a>
		</motion.footer>
	)
}

export default Credits;
